import Postback from './Postback';
import Url from './Url';
import MailTo from './MailTo';
import CallTo from './CallTo';
import File from './File';
import ContentButton from './ContentButton';
import Location from './Location';

const types = {
  postback: Postback,
  url: Url,
  mailto: MailTo,
  callto: CallTo,
  file: File,
  contentButton: ContentButton,
  location: Location
};

export default types;
